import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1z","key":"svg-0"}]]

const IconBrandVisualStudio = createReactComponent('outline', 'brand-visual-studio', 'BrandVisualStudio', __iconNode);

export default IconBrandVisualStudio;